import React, { useState } from 'react';
import slideImage1 from '../../assets/images/personal.png';
import slideImage2 from '../../assets/images/forum.png';
import './Carousel.scss';

type Slide = {
  image: string;
  link: string;
};

const Carousel = ({}: {}) => {
  const [index, setIndex] = useState(0);
  const slides: Slide[] = [
    {
      image: slideImage1,
      link: 'https://www.yevheniivolotskov.com',
    },
    {
      image: slideImage2,
      link: 'https://awesome.yevheniivolotskov.com',
    },
  ];
  const activeSlide = slides[index];

  const PreviousButton = () => (
    <button
      className="cta-button"
      onClick={() => setIndex((index - 1 + slides.length) % slides.length)}
    >
      ←
    </button>
  );

  const NextButton = () => (
    <button
      className="cta-button"
      onClick={() => setIndex((index + 1) % slides.length)}
    >
      →
    </button>
  );

  return (
    <div>
      <div className="carousel">
        <div className="carousel-button">
          <PreviousButton />
        </div>
        <a href={activeSlide.link} target="_blank" rel="noopener noreferrer">
          <img
            key={index}
            className="carousel-image"
            src={activeSlide.image}
            alt={`slide ${index + 1}`}
          />
        </a>
        <div className="carousel-button">
          <NextButton />
        </div>
      </div>
      <div className="carousel-mobile-container">
        <PreviousButton />
        <NextButton />
      </div>
    </div>
  );
};

export default Carousel;
